import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FiscalProfileOutput } from '../../../models/doctor-model';
import { StsPrivateClient } from './sts-models';

export type StsExpenseViewMode = 'workflow' | 'ready';

/** Holds STS expense form state between the edit and review steps. */
@Injectable({ providedIn: 'root' })
export class StsExpenseService {
  invoiceForm: FormGroup | null = null;
  doctorFiscalProfile: FiscalProfileOutput | null = null;
  privateClients: StsPrivateClient[] = [];
  nextLineTrackId = 0;
  /** Set when editing an existing STS expense from the list. */
  editingInvoiceId: string | null = null;
  /** `ready` when opened from the invoices list (read-only summary). */
  viewMode: StsExpenseViewMode = 'workflow';

  get isReadyView(): boolean {
    return this.viewMode === 'ready';
  }

  hasDraft(): boolean {
    return this.invoiceForm !== null;
  }

  saveDraft(
    invoiceForm: FormGroup,
    doctorFiscalProfile: FiscalProfileOutput,
    privateClients: StsPrivateClient[],
    nextLineTrackId: number,
    editingInvoiceId: string | null = null
  ): void {
    this.invoiceForm = invoiceForm;
    this.doctorFiscalProfile = doctorFiscalProfile;
    this.privateClients = privateClients;
    this.nextLineTrackId = nextLineTrackId;
    this.editingInvoiceId = editingInvoiceId;
  }

  clear(): void {
    this.invoiceForm = null;
    this.doctorFiscalProfile = null;
    this.privateClients = [];
    this.nextLineTrackId = 0;
    this.editingInvoiceId = null;
    this.viewMode = 'workflow';
  }
}
